export default __webpack_public_path__ + "static/media/psf.96285290.png";